import { createSubjectAttributes } from 'experimentation-client-js';

import { getDefaultState } from './defaults';
import type { Attributes } from './types';

export const buildSubjectAttributes = (extra: Attributes = {}) => {
    const state = getDefaultState();

    if (!state) return null;

    const { subjectId, stableId, attrs } = state;
    const merged = { ...attrs, ...extra };

    return createSubjectAttributes(subjectId, stableId, merged);
};
